export default __webpack_public_path__ + "static/media/product-open-collector.8c8c046c.svg";